import { Injectable } from '@angular/core';
import { TranslationLocalService } from 'gung-standard';
import seTranslations from '../i18n/se.json';
import enTranslations from '../i18n/en.json';
import deTranslations from '../i18n/de.json';
import esTranslations from '../i18n/es.json';
import frTranslations from '../i18n/fr.json';
import itTranslations from '../i18n/it.json';
import { HttpBackend, HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CarLinerTranslationLocalService extends TranslationLocalService {
  constructor(protected http: HttpClient, protected handler: HttpBackend) {
    super(http, handler);
  }

  protected async getCustTranslations(lang: string): Promise<any> {
    if (lang === 'se') {
      return seTranslations;
    }
    if (lang === 'en') {
      return enTranslations;
    }
    /** Deployed on test branch, uncomment/merge again when done*/
     if (lang === 'de') {
      return deTranslations;
    }
    if (lang === 'es') {
      return esTranslations;
    }
    if (lang === 'fr') {
      return frTranslations;
    }
    if (lang === 'it') {
      return itTranslations;
    }
    return {};
  }
}
